export const filterAndMapAttributes = (attributesObj: Record<string, string | number | boolean | undefined>) => {
  return Object.entries(attributesObj)
    .map(([key, value]) => ({ key, value: value?.toString() }))
    .filter(item => item.value) as Array<{ key: string; value: string }>;
};
